import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import ScoopsPage from "@/pages/scoops/page";
import ScoopDetailPage from "@/pages/scoop-detail/page";
import TopicsPage from "@/pages/topics/page";
import SubmitPage from "@/pages/submit/page";
import FaqPage from "@/pages/faq/page";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "scoops", element: <ScoopsPage /> },
      { path: "scoops/:id", element: <ScoopDetailPage /> },
      { path: "topics", element: <TopicsPage /> },
      { path: "submit", element: <SubmitPage /> },
      { path: "faq", element: <FaqPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;